import React from "react";
import InputNormal from "../../components/InputNormal";
import { HiOutlineUpload } from "react-icons/hi";
import ButtonPrimary from "../../components/ButtonPrimary";
import { Row, Col } from "reactstrap";

export default function AddNewStudent() {
  return (
    <div>
      <div className="box-add-new-student-by-nile">
        <div className="row-jcct-py">
          <p
            style={{
              color: "#134e96",
              fontSize: "1.2rem",
              marginBottom: "10px",
            }}
            className="txt-sub-explanation1"
          >
            New Student
          </p>
        </div>

        <Row>
          <Col xs={12} sm={12} md={12} lg={6} xl={6}>
            <div className="box-main-name-add-new-student">
              <InputNormal title={"First Name"} />
              <InputNormal title={"Last Name"} />
            </div>
          </Col>

          <Col xs={12} sm={12} md={6} lg={3} xl={3}>
            <div className="padding-div-border-input-field-add-new-student">
              <InputNormal title={"Class"} />
              <InputNormal title={"Room"} />
            </div>
          </Col>

          <Col xs={12} sm={12} md={6} lg={3} xl={3}>
            <div className="col-aict padding-div-border-input-field-add-new-student div-upload-image-add-new-student">
              <div className="box-image-train-new-student">
                <HiOutlineUpload size={"2.6rem"} />
                <p className="txt-unfocus1">Click to Upload</p>
              </div>
              <p className="txt-sub-explanation1">Profile Pic</p>
              <p className="txt-unfocus1">Use From Activities</p>
            </div>
          </Col>

          <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <div className="padding-div-border-input-field-add-new-student">
              <InputNormal title={"Student ID"} />
            </div>
          </Col>

            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <div className="padding-div-border-input-field-add-new-student">
              <InputNormal title={"Club"} />
            </div>
          </Col>

            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <div className="padding-div-border-input-field-add-new-student">
              <InputNormal title={"Adviser Name"} />
            </div>
          </Col>

            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <div className="padding-div-border-input-field-add-new-student">
              <InputNormal
                title={
                  "Parent Name (Father , Mother or etc..)"
                }
              />
            </div>
          </Col>

          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="padding-div-border-input-field-add-new-student">
              <InputNormal title={"Remark"} />
            </div>
          </Col>
        </Row>

      </div>
    </div>
  );
}

// import React from "react";
// import InputNormal from "../../components/InputNormal";
// import { HiOutlineUpload } from "react-icons/hi";
// import ButtonPrimary from "../../components/ButtonPrimary";

// export default function AddNewStudent() {
//   return (
//     <div>
//       <div className="box-add-new-student">
//         <div className="row-jcct-py">
//           <p style={{ color: "#134e96" }} className="txt-sub-explanation1">
//             New Student
//           </p>
//         </div>
//         <div className="row-gab2-w100">
//           <div className="col-gab1-w50">
//             <div className="box-main-name-add-new-student">
//               <InputNormal title={"First Name"} />
//               <InputNormal title={"Last Name"} />
//             </div>
//             <InputNormal title={"Student ID"} />
//             <InputNormal title={"Adviser Name"} />
//           </div>
//           <div className="col-gab1-w50">
//             <div className="row-gab1">
//               <div>
//                 <InputNormal title={"Class"} />
//                 <InputNormal title={"Room"} />
//               </div>
//               <div className="col-aict">
//                 <div className="box-image-train-new-student">
//                   <HiOutlineUpload size={"2.6rem"} />
//                   <p className="txt-unfocus1">Click to Upload</p>
//                 </div>
//                 <p className="txt-sub-explanation1">Profile Pic</p>
//                 <p className="txt-unfocus1">Use From Activities</p>
//               </div>
//             </div>
//             <InputNormal title={"Club"} />
//             <InputNormal
//               title={"Parent Name (Father , Mother , Uncle, Brother or etc..)"}
//             />
//           </div>
//         </div>
//         <InputNormal title={"Remark"} />
//       </div>
//       <div className="row-jcct">
//         <ButtonPrimary
//           style={{ margin: "2rem 0", padding: "0.6rem 10rem" }}
//           className={"primary-button"}
//           text={"Save"}
//         />
//       </div>
//     </div>
//   );
// }
